import { render, staticRenderFns } from "./ContactUS.vue?vue&type=template&id=0c2325b0&scoped=true&"
import script from "./ContactUS.vue?vue&type=script&lang=js&"
export * from "./ContactUS.vue?vue&type=script&lang=js&"
import style0 from "./ContactUS.vue?vue&type=style&index=0&id=0c2325b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2325b0",
  null
  
)

export default component.exports